// extracted by mini-css-extract-plugin
export default {"title":"HomepageContent_title__lc74A","header":"HomepageContent_header__XJavO"};